import { render, staticRenderFns } from "./IndexPosterEdit.vue?vue&type=template&id=5b6bd9a0&scoped=true&"
import script from "./IndexPosterEdit.vue?vue&type=script&lang=js&"
export * from "./IndexPosterEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b6bd9a0",
  null
  
)

export default component.exports